/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectsLoader_financialsMultiCurrencies = {
    readonly financialNumbers: {
        readonly billablePlannedTimeAndExpenses: number | null;
        readonly actualRevenue: number | null;
        readonly remainingRevenue: number | null;
        readonly forecastRevenue: number | null;
        readonly recognitionOpenRevenue: number | null;
        readonly recognitionForecastRevenue: number | null;
        readonly recognitionLockedRevenue: number | null;
        readonly plannedCost: number | null;
        readonly actualCost: number | null;
        readonly forecastCost: number | null;
        readonly remainingCost: number | null;
        readonly plannedProfit: number | null;
        readonly forecastProfit: number | null;
        readonly invoiced: number | null;
        readonly paid: number | null;
    } | null;
    readonly financialNumbersProjectCurrency: {
        readonly billablePlannedTimeAndExpenses: number | null;
        readonly actualRevenue: number | null;
        readonly remainingRevenue: number | null;
        readonly forecastRevenue: number | null;
        readonly recognitionOpenRevenue: number | null;
        readonly recognitionForecastRevenue: number | null;
        readonly recognitionLockedRevenue: number | null;
        readonly plannedCost: number | null;
        readonly actualCost: number | null;
        readonly forecastCost: number | null;
        readonly remainingCost: number | null;
        readonly plannedProfit: number | null;
        readonly forecastProfit: number | null;
        readonly invoiced: number | null;
        readonly paid: number | null;
    } | null;
    readonly " $refType": "ProjectsLoader_financialsMultiCurrencies";
};
export type ProjectsLoader_financialsMultiCurrencies$data = ProjectsLoader_financialsMultiCurrencies;
export type ProjectsLoader_financialsMultiCurrencies$key = {
    readonly " $data"?: ProjectsLoader_financialsMultiCurrencies$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProjectsLoader_financialsMultiCurrencies">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "billablePlannedTimeAndExpenses",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actualRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionOpenRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionForecastRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionLockedRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plannedCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actualCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plannedProfit",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastProfit",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "invoiced",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "paid",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectsLoader_financialsMultiCurrencies",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialNumbers",
      "kind": "LinkedField",
      "name": "financialNumbers",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialNumbers",
      "kind": "LinkedField",
      "name": "financialNumbersProjectCurrency",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
})();
(node as any).hash = '5606fabbfdca7f251fa6a4717f24c313';
export default node;
